import { Button } from "../../ui/button";
import { Check, ArrowLeft, Eye, EyeOff } from "lucide-react";
import { Link } from "react-router-dom";

interface EditorHeaderProps {
  title: string;
  isPublished: boolean;
  onSave: () => void;
  onPublishToggle: () => void;
  saving: boolean;
  publishing: boolean;
}

export function EditorHeader({
  title,
  isPublished,
  onSave,
  onPublishToggle,
  saving,
  publishing,
}: EditorHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row justify-between items-center pb-4 border-b border-border/80 text-left gap-4">
      <div className="flex items-center gap-3">
        <Link to="/blog">
          <Button variant="ghost" size="icon" className="h-9 w-9 rounded-xl border border-border/40">
            <ArrowLeft className="h-5 w-5" />
          </Button>
        </Link>
        <div>
          <h4 className="text-xl font-bold text-foreground truncate max-w-[250px] sm:max-w-[400px]">
            {title || "New Article"}
          </h4>
          <p className="text-[10px] text-muted-foreground mt-0.5 uppercase tracking-wider">
            Workspace / Blog Editor
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2.5">
        <Button
          type="button"
          onClick={onPublishToggle}
          disabled={publishing}
          className={`${isPublished
              ? "bg-destructive text-white hover:bg-destructive/90"
              : "bg-emerald-600 text-white hover:bg-emerald-700"
            } font-bold rounded-xl h-10 px-4`}
        >
          {isPublished ? (
            <><EyeOff className="h-4 w-4 mr-2" /> Unpublish</>
          ) : (
            <><Eye className="h-4 w-4 mr-2" /> Publish</>
          )}
        </Button>

        <Button
          type="button"
          onClick={onSave}
          disabled={saving}
          className="bg-brand-primary text-white hover:bg-brand-primary/95 font-bold rounded-xl h-10 px-4"
        >
          <Check className="h-4 w-4 mr-2" />
          {saving ? "Saving..." : "Save"}
        </Button>
      </div>
    </div>
  );
}
